export default __webpack_public_path__ + "static/media/FONDO_FRIJOLES.6713b28a.png";